import * as angular from 'angular';
import {AccountModel} from "../../account/angular/models/account.model";
import {ConfirmDialogService} from "../../commons/services/confirm-dialog.service";

export class ShippersDialogService {

  /* @ngInject */
  constructor(private $filter, private confirmDialogService: ConfirmDialogService, private $mdDialog) {
  }

  onActivateOrDeactivateShipper(shipper, $event) {


    const shipperFullName = shipper.holder === "USER" ? `${shipper.user.firstName} ${shipper.user.lastName}` : shipper.displayName;
    const title = `${shipper.active ? 'Reactivate' : 'Deactivate'} Shipper`;

    return this.confirmDialogService.confirmWithInfo(title, 'SHIPPER_ACTIVE_TOGGLE', null, {
      status: shipper.active ? 'reactivate' : 'deactivate',
      name: shipperFullName,
      access: shipper.active ? '' : 'no longer'
    }, $event);
    // .then(() => {
    //   this.bringozLoaderService.on();
    //   this.$shipper(shipper.id).$update(shipper)
    //     .then(() => {
    //       this.commonsAlertsService.preferencesByNameSuccess('User Status');
    //     })
    //     .catch((error) => {
    //       this.commonsAlertsService.preferencesError();
    //     })
    //     .finally(() => {
    //       this.bringozLoaderService.off();
    //     })
    // })
    // .catch(() => {
    //   this.$log.info('Dialog Closed');
    // })
  }

  createShipperAPI(event, account: AccountModel) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/create-shipper-for-api-dialog.html').default,
      controller: function ($scope, $mdDialog) {

        $scope.cancel = $mdDialog.cancel;

        $scope.shipper = {
          displayName: '',
          accountId: account.id
        }

        /////////////////////////////////////////////////////////////////

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              self.$mdDialog.hide($scope.shipper);
            }
          }
        }
      },
      targetEvent: event,
      clickOutsideToClose: false
    });
  }

  showShipperAPI(event, shipper) {
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/show-shipper-api-dialog.html').default,
      controller: function ($scope, $mdDialog) {

        $scope.cancel = $mdDialog.cancel;
        $scope.shipper = shipper;

        /////////////////////////////////////////////////////////////////

      },
      targetEvent: event,
      clickOutsideToClose: false
    });
  }


}

angular
  .module('bringoz.admin.shippers')
  .service('shippersDialogService', ShippersDialogService);
